import { message } from 'antd';
import axios from 'axios';
import { notificationError } from './notification';

export const serverUrl = import.meta.env.PROD ? window.location.origin : 'http://localhost:7979/'
export const baseURL = import.meta.env.PROD ? window.location.origin + '/api/':'http://localhost:7979/api/'
//export const serverUrl = 'http://localhost:7979/'
//export const baseURL = 'http://localhost:7979/api'

const headers = {
    "Accept": "*/*",
}

export const Api = axios.create({
    withCredentials: true,
    baseURL,
    headers,
})

/* Api.interceptors.response.use((response) => response, (error) => {
    if(window.location.pathname !== '/') {
        throw error;
    }
});
 */